import { IconButton, ListItemButton, ListItemIcon, ListItemText, Tooltip } from "@mui/material";
import { DarkMode, LightMode } from "@mui/icons-material";
import { useAppThemeSwitchContext } from "../../providers/ThemeProvider";

// Tiny theme-toggle that adapts to the drawer's collapsed state. When
// expanded, it reads as a labeled menu item; when collapsed it's just
// the icon (with tooltip).

export function DrawerThemeToggle({ collapsed = false }: { collapsed?: boolean }) {
  const { mode, setPaletteMode } = useAppThemeSwitchContext();
  const isDark = mode === "dark";
  const next = isDark ? "light" : "dark";
  const label = isDark ? "Light mode" : "Dark mode";

  if (collapsed) {
    return (
      <Tooltip title={label} placement="right">
        <IconButton onClick={() => setPaletteMode(next)} aria-label="toggle theme">
          {isDark ? <LightMode /> : <DarkMode />}
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <ListItemButton
      onClick={() => setPaletteMode(next)}
      sx={{ borderRadius: 1, paddingY: 0.75, paddingX: 1 }}
    >
      <ListItemIcon
        sx={{ minWidth: 24, marginRight: 1.5, color: "text.secondary" }}
      >
        {isDark ? <LightMode /> : <DarkMode />}
      </ListItemIcon>
      <ListItemText primary={label} primaryTypographyProps={{ variant: "body2" }} />
    </ListItemButton>
  );
}
